import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { PdfViewer } from "components/common/PdfViewer";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { TeamcardLinkageEmail } from "./TeamcardLinkageEmail";
import { TeamcardLinkageLandingPage } from "./TeamcardLinkageLandingPage";
import { TeamcardLinkageMatchError } from "./TeamcardLinkageMatchError";
import { TeamcardLinkageRoutes } from "./TeamcardLinkageRoutes";
import { TeamcardLinkageSigning } from "./TeamcardLinkageSigning";
import { TeamCardLinkageSMSVerfication } from "./TeamCardLinkageSMSVerfication";
import { TeamcardLinkageStore } from "./TeamcardLinkageStore";
import { TeamcardLinkageSuccess } from "./TeamcardLinkageSuccess";

type IProps = RouteComponentProps & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

const DEBUG_LOCALLY = false;

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export default class TeamCardLinkageContainer extends React.Component<IProps> {
    store: TeamcardLinkageStore;

    constructor(props: any) {
        super(props);
        this.store = new TeamcardLinkageStore();
    }

    async componentDidMount() {
        if (DEBUG_LOCALLY) {
            return;
        }

        // Go to root page on feature start
        pushRoute(TeamcardLinkageRoutes.ROOT);

        const error = await this.store.loadData();
        if (error) {
            debug.log("### TeamcardLinkageContainer.componentDidMount() Failed to load data", error);

            if (error === "customError") {
                pushRoute(TeamcardLinkageRoutes.MATCH_ERROR);
            } else if (!config.DEBUG) {
                pushRoute("/error");
            }
        } else {
            try {
                await this.store.requestSMSCode();
                pushRoute(TeamcardLinkageRoutes.SMS_VERIFICATION);
            } catch (error) {
                debug.log("### TeamcardLinkageContainer.componentDidMount() Failed to request SMS code", error);
                pushRoute(TeamcardLinkageRoutes.MATCH_ERROR);
            }
        }

    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    render() {
        document.title = ui.__("teamcardLinkage.page.title");
        return (
            <div>
                <Route exact path={TeamcardLinkageRoutes.ROOT} component={this.withStore(TeamcardLinkageLandingPage)} />
                <Route exact path={TeamcardLinkageRoutes.EMAIL} component={this.withStore(TeamcardLinkageEmail)} />
                <Route exact path={TeamcardLinkageRoutes.SIGNING} component={this.withStore(TeamcardLinkageSigning)} />
                <Route exact path={TeamcardLinkageRoutes.SUCCESS} component={this.withStore(TeamcardLinkageSuccess)} />
                <Route exact path={TeamcardLinkageRoutes.SMS_VERIFICATION} component={this.withStore(TeamCardLinkageSMSVerfication)} />
                <Route exact path={TeamcardLinkageRoutes.MATCH_ERROR} component={this.withStore(TeamcardLinkageMatchError)} />
                <Route path={TeamcardLinkageRoutes.PDF} component={() => <PdfViewer {...this.props} uint8Data={this.store.pdfData} />} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/teamcardLinkage/TeamcardLinkageContainer.tsx